const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1024 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-1087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2",
    transform: "matrix(1,0,0,1,0,1087.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.133,1021.18C200.822,994.23 0,776.382 0,512C0,229.42 229.42,0 512,0C794.58,0 1024,229.42 1024,512C1024,621.669 989.444,723.332 930.605,806.695C909.055,786.59 883.363,769.862 854.059,757.772C724.052,704.133 571.878,761.969 514.448,886.844C494.032,931.238 475.209,976.243 458.133,1021.18ZM299.548,611.939C305.75,618.184 308.538,627.049 307.028,635.719C289.065,739.031 312.54,828.362 406.105,894.062C414.94,900.339 426.332,902.384 437.037,899.615C447.742,896.845 456.588,889.565 461.058,879.846C461.083,879.855 461.084,879.853 461.085,879.852C467.172,866.615 463.132,851.208 451.274,842.439C394.917,801.314 381.215,746.545 400.154,681.334C403.479,669.758 414.035,661.758 426.079,661.686C552.333,660.691 698.813,554.183 677.11,282.499C558.868,325.769 499.982,389.774 460.61,495.988C459.624,498.663 457.094,500.456 454.244,500.502C451.393,500.548 448.807,498.837 447.734,496.196C401.577,381.878 467.059,242.544 603.798,164.487C250.88,128.655 192.492,450.726 274.82,580.875C282.149,592.46 290.449,602.819 299.548,611.939Z",
    style: {
      fill: "rgb(228,45,94)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.1b21efe859cd5d748ce1c65b84fe22bd.svg";
export { ForwardRef as ReactComponent };